import { HubConnectionBuilder, HubConnectionState, LogLevel, } from "@microsoft/signalr";
import { tokenManager } from "./token-manager.js";
export const CONFIGURATION_ENTITY_MAP = {
    Brand: "/api/Brand",
    Customer: "/api/Customer",
    Workflow: "/api/Workflow",
    List: "/api/workflow/{workflowId}/List",
    Field: "/api/workflow/{workflowId}/Field",
    Status: "/api/workflow/{workflowId}/Status",
    Folder: "/api/brand/{brandId}/Folder",
};
export const FILE_ENTITY_MAP = {
    Task: "/api/Task",
    Item: "/api/task/{taskId}/item",
};
export const ENTITY_ACTIONS = {
    Created: "Created",
    Updated: "Updated",
    Deleted: "Deleted",
    Complete: "Complete",
};
const waitForConnection = async (connection) => {
    if (connection.state === HubConnectionState.Connected)
        return;
    while (connection.state === HubConnectionState.Connecting ||
        connection.state === HubConnectionState.Reconnecting) {
        await new Promise((resolve) => setTimeout(resolve, 50));
    }
    if (connection.state !== HubConnectionState.Connected) {
        throw new Error("Cannot subscribe: SignalR connection is not open.");
    }
};
export const createSyncApi = (baseUrl) => {
    const subscribedEntities = new Set();
    const connection = new HubConnectionBuilder()
        .withUrl(`${baseUrl}/sync`, {
        withCredentials: true,
        accessTokenFactory: () => tokenManager.getToken() ?? "",
    })
        .withAutomaticReconnect([0, 1000, 2000, 5000, 10000, 30000])
        .configureLogging(LogLevel.Information)
        .build();
    connection.onreconnected(async () => {
        for (const entityName of subscribedEntities) {
            try {
                await connection.invoke("SubscribeToEntity", entityName);
                console.log(`[SignalR] Re-subscribed to ${entityName} after reconnect`);
            }
            catch (err) {
                console.error(`[SignalR] Failed to re-subscribe to ${entityName}`, err);
            }
        }
    });
    return {
        connection,
        start: async () => {
            if (connection.state === HubConnectionState.Disconnected) {
                await connection.start();
            }
        },
        stop: async () => connection.stop(),
        subscribeToEntity: async (entityName) => {
            subscribedEntities.add(entityName);
            try {
                await waitForConnection(connection);
                await connection.invoke("SubscribeToEntity", entityName);
                console.log(`[SignalR] Successfully subscribed to ${entityName}`);
            }
            catch (err) {
                console.error(`[SignalR] Failed to subscribe to ${entityName}`, err);
            }
        },
        unsubscribeFromEntity: async (entityName) => {
            subscribedEntities.delete(entityName);
            if (connection.state === HubConnectionState.Connected) {
                await connection.invoke("UnsubscribeFromEntity", entityName);
            }
        },
        onEntityChanged: (callback) => {
            connection.on("EntityChanged", callback);
            return () => connection.off("EntityChanged", callback);
        },
    };
};
//# sourceMappingURL=sync-api.js.map